import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/ncDeclaration'

const ncDeclaration = axios.create({
  baseURL
})

interceptorsSetup(ncDeclaration)

export default class NCDeclaration {
  static async getTable (ncQuery) {
    const result = await ncDeclaration.get('/some/' + ncQuery.siteId, {
      params:
      {
        start: ncQuery.start,
        end: ncQuery.end
      }
    })
    return result.data
  }
  static async getAllTable (ncQuery) {
    const result = await ncDeclaration.get('/all', {
      params:
      {
        start: ncQuery.start,
        end: ncQuery.end
      }
    })
    return result.data
  }
  static async createNC (nc) {
    const result = await ncDeclaration.post('/', nc)
    return result.data
  }
  static async updateNC (nc) {
    const result = await ncDeclaration.post('/update', nc)
    return result.data
  }
  static async archiveNC (nc) {
    const result = await ncDeclaration.put('/archive/' + nc)
    return result.data
  }
}
